import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { Typography } from '@comparethemarketau/manor-typography';

const useStyles = createUseStyles((theme) => ({
    limitSpecialConditionsContainer: {
        
    },
    title: {
        fontSize: theme.fontSize.xs,
        lineHeight: theme.lineHeight.tighter,
        fontWeight: theme.fontWeight.bold,
        marginBottom: theme.spacing[4],
        color: theme.colors.grey600
    },
    content: {
        '& li:nth-of-type(n+10)': {
            display: 'none'
        },
        '& li:not(:only-child)': {
            listStyleType: 'disc',
            listStylePosition: 'outside',
            marginLeft: theme.spacing[8]
        },
        '& :only-child:not(ul)': {
            marginLeft: `-${theme.spacing[16]}`
        },
        paddingLeft: theme.spacing[16],
        fontSize: theme.fontSize.sm,
        lineHeight: theme.lineHeight.snug,
        fontWeight: theme.fontWeight.normal,
        color: theme.colors.grey800
    }
}));

const LimitSpecialConditionsXS = (props) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });
    const { specialConditions, removeTitle, productId } = props;

    if (!specialConditions) {
        return null;
    }

    // another option is using DOM node firstChild property
    let specialConditionsWrapped = specialConditions;
    if (!specialConditionsWrapped.includes('</')) {
        specialConditionsWrapped = `<ul><li>${specialConditionsWrapped}</li></ul>`;
    }

    return (
        <div className={classes.limitSpecialConditionsContainer}>
            {!removeTitle && <Typography className={classes.title}>SPECIAL CONDITIONS</Typography>}
            <div
                id={getLimitSpecialConditionsElementId(productId)}
                dangerouslySetInnerHTML={{ __html: specialConditionsWrapped }}
                className={classNames(classes.content)}
            />
        </div>
    );
};

const getLimitSpecialConditionsElementId = (productId) => {
    return `special-conditions-for-${productId}`;
};

LimitSpecialConditionsXS.propTypes = {
    specialConditions: PropTypes.string,
    removeTitle: PropTypes.bool,
    productId: PropTypes.string
};

export { LimitSpecialConditionsXS, getLimitSpecialConditionsElementId };
